import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '../../../../shared/components';
import { BasicNotification } from '../../../../shared/components/Notification';

interface ActionPlanDeleteModalProps {
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  actionPlanId: number;
  callback: (idAP: number) => void;
}

const ActionPlanDeleteModal: React.FC<ActionPlanDeleteModalProps> = (props) => {
  const { actionPlanId, visible, setVisible, callback } = props;
  const { t } = useTranslation();

  const deleteAction = (id: number) => {
    setVisible(false);
    callback(id);
  };

  return (
    <Modal
      title={t('deleteActionPlan')}
      visible={visible}
      setVisible={setVisible}
      actions={[
        { text: t('cancel'), action: () => setVisible(false) },
        { text: t('confirm'), action: () => deleteAction(actionPlanId) },
      ]}
      onClosed={() => setVisible(false)}
      customClass="flow-delete-modal"
    >
      <BasicNotification
        message={t('deleteActionPlanMessageWarningRelated')}
        color="warning"
        icon="exclamation-triangle"
      />
    </Modal>
  );
};

export default ActionPlanDeleteModal;
